import baseApp from '../innerAPP'
import App from './App.vue'
;(async () => {
  const vm = await baseApp(App)
  vm.mount('#app')
})()
